/** output deprecated message in console for warning */
export function deprecated(msg: string): void {
	console.warn("DEPRECATED: " + msg);
}